module.exports = ":host {\n  display: contents; }\n\na.disabled {\n  pointer-events: auto;\n  cursor: not-allowed; }\n"